package sarka.design.skoria.ui


import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.jetbrains.compose.ui.tooling.preview.Preview
import sarka.design.skoria.model.Strings
import sarka.design.skoria.ui.composables.HomeButton
import sarka.design.skoria.ui.composables.SkoriaSecondaryButton
import sarka.design.skoria.ui.theme.RCTheme
import skoria.composeapp.generated.resources.Res
import skoria.composeapp.generated.resources.skoria_logo

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun HomeScreen(
    username: String?,
    /** False when there's no session, e.g. after Fake Login. */
    isLoggedIn: Boolean,
    onVideoChatClick: () -> Unit,
    onTextChatClick: () -> Unit,
    onLogout: () -> Unit
) {
    Scaffold(
        topBar = {
            TopAppBar(
                title = {
                    Row(
                        modifier = Modifier.fillMaxWidth().padding(8.dp),
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Text(
                            text = username?.let { "Logged in as $it" } ?: "",
                            color = RCTheme.colors.onSurface,
                            fontSize = 16.sp
                        )

                        SkoriaSecondaryButton(
                            text = "Logout",
                            onClick = onLogout
                        )
                    }
                }
            )
        }
    ) { padding ->
        Surface(
            modifier = Modifier.padding(padding).fillMaxSize(),
        ) {
            Column(
                modifier = Modifier.fillMaxSize(),
            ) {


                // Messaging needs a real account so messages can be delivered to a
                // known user. Video chat doesn't, so only this is called out.
                if (!isLoggedIn) {
                    Text(
                        text = "Text Chat needs an account. Log in to use messaging.",
                        color = RCTheme.colors.error,
                        fontSize = 14.sp,
                        modifier = Modifier.padding(horizontal = 8.dp, vertical = 4.dp)
                    )
                }

                Row(
                    modifier = Modifier.fillMaxSize(),
                ) {
                    HomeButton(
                        titleText = Strings.SKORIA_VIDEO_CHAT,
                        illustration = Res.drawable.skoria_logo,
                        onCardClick = onVideoChatClick
                    )

                    HomeButton(
                        titleText = Strings.SKORIA_NEWS,
                        illustration = Res.drawable.skoria_logo,
                        onCardClick = onVideoChatClick
                    )

                    HomeButton(
                        titleText = Strings.SKORIA_TEXT_CHAT,
                        illustration = Res.drawable.skoria_logo,
                        // Ignored without a session; the notice above explains why.
                        onCardClick = { if (isLoggedIn) onTextChatClick() }
                    )
                }
            }
        }
    }

}

@Composable
@Preview
private fun HomeScreenPreview() {
    RCTheme {
        HomeScreen(
            username = "alice",
            isLoggedIn = true,
            onVideoChatClick = {},
            onTextChatClick = {},
            onLogout = {},
        )
    }
}

@Composable
@Preview
private fun HomeScreenPreviewNotLoggedIn() {
    RCTheme {
        HomeScreen(
            username = null,
            isLoggedIn = false,
            onVideoChatClick = {},
            onTextChatClick = {},
            onLogout = {},
        )
    }
}

@Composable
@Preview
private fun HomeScreenPreviewDark() {
    RCTheme(darkTheme = true) {
        HomeScreen(
            username = "alice",
            isLoggedIn = true,
            onVideoChatClick = {},
            onTextChatClick = {},
            onLogout = {},
        )
    }
}
